import { SendOutlined } from '@mui/icons-material';

const OurSendMailIcon = () => <SendOutlined style={{ transform: 'rotate(-45deg)' }} />;

export default OurSendMailIcon;
